function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Heading } from '@domain-group/fe-co-allhomes-design-system';
import DoughnutGraph from '../doughnut-graph/doughnut-graph';
import commonPropTypes from '../../common-props';
import Stats from '../simple-stat';
import * as styles from './suburb-summary.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var serverSideColours = ['#000', '#000', '#000', '#000', '#000', '#000'];
var SuburbSummary = _ref => {
  var averageAge = _ref.averageAge,
    population = _ref.population,
    profileData = _ref.profileData,
    occupancyData = _ref.occupancyData,
    suburbName = _ref.suburbName,
    layout = _ref.layout,
    disableAnimation = _ref.disableAnimation,
    className = _ref.className;
  // Colours need to be resolved only during client-side render.
  var _useState = useState({
      resolved: false,
      profile: serverSideColours.slice(0, 4),
      occupancy: serverSideColours
    }),
    _useState2 = _slicedToArray(_useState, 2),
    colours = _useState2[0],
    setColours = _useState2[1];
  useEffect(() => {
    if (!colours.resolved) {
      setColours({
        resolved: true,
        profile: styles.profileDataColours(),
        occupancy: styles.occupancyDataColours()
      });
    }
  }, [colours.resolved]);
  return ___EmotionJSX("div", {
    css: styles.suburbSummary,
    className: className
  }, layout !== 'no-title' && ___EmotionJSX(Heading, {
    title: "".concat(suburbName, " suburb information"),
    subtitle: "A little bit about who lives locally, as provided by government census data"
  }), ___EmotionJSX("div", {
    css: styles.stats
  }, averageAge && ___EmotionJSX(Stats, {
    label: "Average Age",
    value: "".concat(averageAge)
  }), population && ___EmotionJSX(Stats, {
    label: "Population",
    value: "".concat(population)
  })), ___EmotionJSX("div", {
    css: styles.graphs
  }, profileData && colours.resolved && ___EmotionJSX(DoughnutGraph, {
    title: "".concat(suburbName, "'s Property Profile"),
    options: {
      disableAnimation
    },
    data: profileData,
    colours: colours.profile
  }), occupancyData && colours.resolved && ___EmotionJSX(DoughnutGraph, {
    title: "".concat(suburbName, "'s Occupancy"),
    options: {
      disableAnimation
    },
    data: occupancyData,
    colours: colours.occupancy
  })));
};
SuburbSummary.propTypes = _objectSpread(_objectSpread({}, commonPropTypes), {}, {
  layout: PropTypes.oneOf(['default', 'no-title'])
});
SuburbSummary.defaultProps = {
  layout: 'default'
};
export default SuburbSummary;